// components/EmailTemplates/TemplateFilters.js
import React from "react";
import {
    Button,
    Card,
    CardBody,
    HStack,
    Icon,
    Input,
    InputGroup,
    InputLeftElement,
    Select,
    useColorModeValue,
    VStack,
} from "@chakra-ui/react";
import {FiSearch} from "react-icons/fi";
import {EMAIL_TEMPLATE_STATUS} from "./constants/emailConstants";

const TemplateFilters = ({
                             searchTerm,
                             setSearchTerm,
                             typeFilter,
                             setTypeFilter,
                             statusFilter,
                             setStatusFilter,
                             isDefaultFilter,
                             setIsDefaultFilter,
                             templateTypes,
                             onClearFilters,
                         }) => {
    const cardBg = useColorModeValue("white", "gray.700");

    return (
        <Card bg={cardBg} mb={6}>
            <CardBody p={{ base: 4, md: 6 }}>
                <VStack spacing={4}>
                    {/* Desktop Layout */}
                    <HStack w="full" spacing={4} display={{ base: "none", lg: "flex" }}>
                        <InputGroup flex={2}>
                            <InputLeftElement pointerEvents="none">
                                <Icon as={FiSearch} color="gray.400"/>
                            </InputLeftElement>
                            <Input
                                placeholder="Search templates..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </InputGroup>

                        <Select
                            placeholder="All Types"
                            value={typeFilter}
                            onChange={(e) => setTypeFilter(e.target.value)}
                            flex={1}
                        >
                            {templateTypes?.map(type => (
                                <option key={type.type} value={type.type}>
                                    {type.label}
                                </option>
                            ))}
                        </Select>

                        <Select
                            placeholder="All Status"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            flex={1}
                        >
                            <option value={EMAIL_TEMPLATE_STATUS.ACTIVE}>Active</option>
                            <option value={EMAIL_TEMPLATE_STATUS.INACTIVE}>Inactive</option>
                            <option value={EMAIL_TEMPLATE_STATUS.DRAFT}>Draft</option>
                        </Select>

                        <Select
                            placeholder="All Templates"
                            value={isDefaultFilter}
                            onChange={(e) => setIsDefaultFilter(e.target.value)}
                            flex={1}
                        >
                            <option value="true">Default Only</option>
                            <option value="false">Non-Default</option>
                        </Select>

                        <Button variant="ghost" onClick={onClearFilters}>
                            Clear
                        </Button>
                    </HStack>

                    {/* Tablet Layout */}
                    <VStack w="full" spacing={3} display={{ base: "none", md: "flex", lg: "none" }}>
                        <InputGroup>
                            <InputLeftElement pointerEvents="none">
                                <Icon as={FiSearch} color="gray.400"/>
                            </InputLeftElement>
                            <Input
                                placeholder="Search templates..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </InputGroup>

                        <HStack w="full" spacing={2}>
                            <Select
                                placeholder="All Types"
                                value={typeFilter}
                                onChange={(e) => setTypeFilter(e.target.value)}
                                flex={1}
                            >
                                {templateTypes?.map(type => (
                                    <option key={type.type} value={type.type}>
                                        {type.label}
                                    </option>
                                ))}
                            </Select>

                            <Select
                                placeholder="All Status"
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                                flex={1}
                            >
                                <option value={EMAIL_TEMPLATE_STATUS.ACTIVE}>Active</option>
                                <option value={EMAIL_TEMPLATE_STATUS.INACTIVE}>Inactive</option>
                                <option value={EMAIL_TEMPLATE_STATUS.DRAFT}>Draft</option>
                            </Select>
                        </HStack>

                        <HStack w="full" spacing={2}>
                            <Select
                                placeholder="All Templates"
                                value={isDefaultFilter}
                                onChange={(e) => setIsDefaultFilter(e.target.value)}
                                flex={1}
                            >
                                <option value="true">Default Only</option>
                                <option value="false">Non-Default</option>
                            </Select>

                            <Button variant="ghost" onClick={onClearFilters}>
                                Clear
                            </Button>
                        </HStack>
                    </VStack>

                    {/* Mobile Layout */}
                    <VStack w="full" spacing={3} display={{ base: "flex", md: "none" }}>
                        <InputGroup>
                            <InputLeftElement pointerEvents="none">
                                <Icon as={FiSearch} color="gray.400"/>
                            </InputLeftElement>
                            <Input
                                placeholder="Search templates..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </InputGroup>

                        <HStack w="full" spacing={2}>
                            <Select
                                placeholder="All Types"
                                value={typeFilter}
                                onChange={(e) => setTypeFilter(e.target.value)}
                                flex={1}
                                size="sm"
                            >
                                {templateTypes?.map(type => (
                                    <option key={type.type} value={type.type}>
                                        {type.label}
                                    </option>
                                ))}
                            </Select>

                            <Select
                                placeholder="All Status"
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                                flex={1}
                                size="sm"
                            >
                                <option value={EMAIL_TEMPLATE_STATUS.ACTIVE}>Active</option>
                                <option value={EMAIL_TEMPLATE_STATUS.INACTIVE}>Inactive</option>
                                <option value={EMAIL_TEMPLATE_STATUS.DRAFT}>Draft</option>
                            </Select>
                        </HStack>

                        <HStack w="full" spacing={2}>
                            <Select
                                placeholder="All Templates"
                                value={isDefaultFilter}
                                onChange={(e) => setIsDefaultFilter(e.target.value)}
                                flex={1}
                                size="sm"
                            >
                                <option value="true">Default Only</option>
                                <option value="false">Non-Default</option>
                            </Select>

                            <Button variant="ghost" onClick={onClearFilters} size="sm">
                                Clear
                            </Button>
                        </HStack>
                    </VStack>
                </VStack>
            </CardBody>
        </Card>
    );
};

export default TemplateFilters;
